<script>
  import NewsBannerCardLoader from './NewsBannerCardLoader.svelte';
  import NewsSmallBannerCardLoader from './NewsSmallBannerCardLoader.svelte';
</script>

<div class="container">
  <NewsBannerCardLoader />
  {#each [1, 2, 3] as item}
    <div class="divider" />
    <NewsSmallBannerCardLoader />
  {/each}
</div>

<style>
  .container {
    padding: 12px;
  }

  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--color-divider);
    opacity: 0.1;
    border-radius: 2px;
  }
</style>
